/* unplugin-vue-components disabled *//* vant-demand-import */
import installComponents from "!../../../plugins/vant-demand-import/installComponents.js"
import VanField from 'vant/es/field'
import 'vant/es/field/style/less'
import VanForm from 'vant/es/form'
import 'vant/es/form/style/less'


import { render, staticRenderFns } from "./advanced.vue.js?vue&type=template&id=49e58cc8!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./advanced.vue?vue&type=template&id=49e58cc8"
import script from "./advanced.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./advanced.vue?vue&type=script&lang=ts&setup=true"
export * from "./advanced.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./advanced.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./advanced.vue.postcss?vue&type=style&index=0&id=49e58cc8&prod&lang=postcss&module=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./advanced.vue?vue&type=style&index=0&id=49e58cc8&prod&lang=postcss&module=true"
import style1 from "./advanced.vue.css?vue&type=style&index=1&id=49e58cc8&prod&lang=css!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./advanced.vue?vue&type=style&index=1&id=49e58cc8&prod&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports
installComponents(component, {VanField,VanForm})
